import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Form, InputGroup, Modal, Row } from '@themesberg/react-bootstrap';
import { useCookies } from "react-cookie";
import Datetime from "react-datetime";
import moment from "moment-timezone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { updatePeriod } from "../controller/api/gamePeriod";

const VIETNAM_TIMEZONE = 'Asia/Ho_Chi_Minh';

const EditPeriodPopup = (props) => {
  const { periodData, gameType } = props;
  const [cookies] = useCookies(['lottmekong']);

  const _onHide = () => {
    props.onHide();
  };

  const [name, setName] = useState('');
  const [resultDate, setResultDate] = useState(null);
  const [resultTime, setResultTime] = useState('');

  // Initialize form with period data
  useEffect(() => {
    if (periodData) {
      setName(periodData.name || '');
      
      // Parse resultDate
      if (periodData.resultDate) {
        const [day, month, year] = periodData.resultDate.split('/');
        setResultDate(moment(`${year}-${month}-${day}`, 'YYYY-MM-DD'));
      }
      
      // Parse resultTime
      if (periodData.dialDate || periodData.resultTime) {
        const time = moment(periodData.dialDate || periodData.resultTime)
          .tz(VIETNAM_TIMEZONE)
          .format('HH:mm');
        setResultTime(time);
      }
    }
  }, [periodData]);

  const _handleChangeName = useCallback((e) => {
    setName(e.target.value);
  }, []);

  const _handleChangeDate = useCallback((date) => {
    setResultDate(date);
  }, []);

  const _handleChangeTime = useCallback((e) => {
    setResultTime(e.target.value);
  }, []);

  const onSubmit = async () => {
    if (!periodData) {
      alert('Dữ liệu kỳ không hợp lệ');
      return;
    }

    // Validate future datetime
    const formattedDate = resultDate.format("DD/MM/YYYY");
    const selectedDateTime = moment.tz(
      `${formattedDate} ${resultTime}`,
      'DD/MM/YYYY HH:mm',
      VIETNAM_TIMEZONE
    );

    if (selectedDateTime.isSameOrBefore(moment())) {
      alert('Thời gian quay số phải là thời gian tương lai');
      return;
    }

    const originalName = periodData.name || '';
    const originalDate = periodData.resultDate || '';
    const originalTime = moment(periodData.dialDate || periodData.resultTime)
      .tz(VIETNAM_TIMEZONE)
      .format('HH:mm');

    const resp = await updatePeriod(
      cookies.lottmekong,
      periodData.id,
      name === originalName ? undefined : name,
      formattedDate === originalDate ? undefined : formattedDate,
      resultTime === originalTime ? undefined : resultTime
    );

    if (resp) {
      window.location.reload();
      _onHide();
    } else {
      alert('Có lỗi xảy ra khi cập nhật kỳ quay số');
      return false;
    }
  };

  const isFutureDateTime = () => {
    if (!resultDate || !resultTime) return false;
    
    const selectedDateTime = moment.tz(
      `${resultDate.format("DD/MM/YYYY")} ${resultTime}`,
      'DD/MM/YYYY HH:mm',
      VIETNAM_TIMEZONE
    );

    return selectedDateTime.isAfter(moment());
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={_onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Chỉnh sửa kỳ quay {gameType || ''}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row>
            <Col md={12} className="mb-2">
              <Form.Group id="name">
                <Form.Label>Tên kỳ</Form.Label>
                <Form.Control 
                  required 
                  type="text" 
                  placeholder="Nhập tên kỳ"
                  value={name}
                  onChange={_handleChangeName} 
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={12} className="mb-2">
              <Form.Label>Ngày quay số</Form.Label>
              <Datetime
                timeFormat={false}
                value={resultDate}
                onChange={_handleChangeDate}
                renderInput={(props, openCalendar) => (
                  <InputGroup>
                    <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                    <Form.Control
                      required
                      type="text"
                      value={resultDate ? resultDate.format("DD/MM/YYYY") : ""}
                      placeholder="dd/mm/yyyy"
                      onFocus={openCalendar}
                      onChange={() => {}}
                    />
                  </InputGroup>
                )}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12} className="mb-2">
              <Form.Group id="time">
                <Form.Label>Giờ quay số</Form.Label>
                <Form.Control 
                  required 
                  type="time" 
                  value={resultTime}
                  onChange={_handleChangeTime} 
                />
              </Form.Group>
            </Col>
          </Row>
          {!isFutureDateTime() && resultDate && resultTime && (
            <Row>
              <Col md={12}>
                <div className="alert alert-warning" role="alert">
                  ⚠️ Thời gian quay số phải là thời gian tương lai
                </div>
              </Col>
            </Row>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={_onHide}>Đóng</Button>
        <Button 
          variant="primary" 
          onClick={onSubmit}
          disabled={!isFutureDateTime()}
        >
          Cập nhật
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditPeriodPopup;
